/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type WarmTransferDto = {
    referralId: string;
    outcome: WarmTransferDto.outcome;
    note?: string;
    reason?: WarmTransferDto.reason;
}

export namespace WarmTransferDto {

    export enum outcome {
        SUCCESS = 'SUCCESS',
        FAIL = 'FAIL',
    }

    export enum reason {
        PATIENT_DECLINED = 'PATIENT_DECLINED',
        UNABLE_TO_REACH = 'UNABLE_TO_REACH',
        OUT_OF_WORKING_HOURS_VACATION = 'OUT_OF_WORKING_HOURS_VACATION',
        VOICEMAIL = 'VOICEMAIL',
        SITE_DECLINED = 'SITE_DECLINED',
        OTHER = 'OTHER',
    }


}
